// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-tab[data-v-b66ee972] {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.02em;\n  color: #a6aebe;\n  text-transform: none !important;\n}\n.tab-active[data-v-b66ee972] {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.02em;\n  color: #081734;\n  text-transform: none;\n}\n.mytab[data-v-b66ee972] {\n  border-bottom: 1px solid #d1d8de;\n}\n", ""]);
// Exports
module.exports = exports;
